import pdv from '@giro-pdv-whitelabel/modules/pdv/store';

const rootSubscribe = (store) => () => {
  pdv.subscriber.subscribe(store);
};

export default rootSubscribe;
